import React from 'react';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import CountOfTotal from '../../../../../components/CountOfTotal';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import { MAXIMUM_NUMBER_OF_REJECT_CANCEL_REASON_TEXT } from '../../../../../constants/service/app/orderConstants';
import { setNumberWithComma } from '../../../../../lib/common';
import { formRequiredRules } from '../../../../../lib/formRules';
import './RejectCancelModal.scss';

const RejectCancelModal = (props) => {
  const { isOpen, data, form, onSubmit, setData, closeModal, rejectReason } = props;
  const { orderItemList = [] } = data;

  return (
    <Modal
      title="취소 거부 처리"
      isOpen={isOpen}
      width={600}
      height={510}
      isFooter={true}
      okText="취소 거부 처리"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="reject-cancel-modal-wrap">
        <div className="reject-cancel-info">
          <div>* 구매자에게 먼저 주문 취소 불가 사유를 안내하고, 거부처리를 진행해 주세요.</div>
          <div>* 취소 거부 사유는 구매자에게 별도 안내되므로, 상세히 입력해 주세요.</div>
        </div>

        <div className="reject-cancel-modal-table-title">선택한 상품 주문 리스트</div>

        <InfoTable className="selected-order-item-list-table">
          <thead>
            <tr>
              <th>상품 주문번호</th>
              <th>상품명</th>
              <th>상품 가격(정가)</th>
            </tr>
          </thead>
          <tbody>
            {orderItemList.map((item, index) => (
              <tr key={index}>
                <td className="tc">{item.orderItemId}</td>
                <td className="tc">{item.productName}</td>
                <td className="tc">{setNumberWithComma(item.productPrice, '원')}</td>
              </tr>
            ))}
          </tbody>
        </InfoTable>

        <div className="reject-cancel-modal-table-title">상세 사유</div>

        <InfoTable className="reject-cancel-table">
          <tbody>
            <tr>
              <td className="label tc">
                <span>취소 거부 상세 사유</span>
                <CountOfTotal content={rejectReason} maxCnt={MAXIMUM_NUMBER_OF_REJECT_CANCEL_REASON_TEXT} />
              </td>
              <td className="tl" colSpan={3}>
                <TextAreaForm
                  form={form}
                  name="reason"
                  rules={[formRequiredRules(true, null)]}
                  initialValue={rejectReason}
                  onChange={(value) =>
                    setData({
                      name: 'rejectReason',
                      value,
                    })
                  }
                  maxLength={MAXIMUM_NUMBER_OF_REJECT_CANCEL_REASON_TEXT}
                />
              </td>
            </tr>
          </tbody>
        </InfoTable>
      </div>
    </Modal>
  );
};

export default RejectCancelModal;
